import FilterListIcon from "@mui/icons-material/FilterList";
import { Box, Button, TableCell, Typography } from "@mui/material";
import React from "react";

import HarvestFilterList from "../components/HarvestFilterList";
import Layout from "../components/Layout";
import { HarvestList, TableColumn } from "../types";
import { extractDate } from "../utils";

const columns: TableColumn<HarvestList>[] = [
  { field: "commodity", label: "Crop", orderBy: false },
  { field: "shipper", label: "Shipper", orderBy: false },
  { field: "lot", label: "Ranch", orderBy: false },
  { field: "lot", label: "Lot #", orderBy: false },
  { field: "desiredNumAcres", label: "Desired Acres", orderBy: false },
  { field: "transplantDate", label: "Transplant Date", orderBy: true },
  { field: "projectedWetDate", label: "Projected Wet Date", orderBy: true },
  { field: "estHarvestDate", label: "Est. Harvest Date", orderBy: true },
  { field: "fieldVarieties", label: "Variety", orderBy: false },
  { field: "bedWidth", label: "Bed Width", orderBy: false },
  { field: "seedLine", label: "Seed Lines", orderBy: false },
];

function buildTableRow(harvest: HarvestList): JSX.Element[] {
  return [
    <TableCell key={"commodity"}>
      {harvest.commodity ? harvest.commodity.name : "N/A"}
    </TableCell>,
    <TableCell key={"shipper"}>
      {harvest.shipper ? harvest.shipper.name : "N/A"}
    </TableCell>,
    <TableCell key={"lot"}>
      {harvest.lot ? harvest.lot?.ranch?.name : "N/A"}
    </TableCell>,
    <TableCell key={"lot"}>{harvest.lot ? harvest.lot.num : "N/A"}</TableCell>,
    <TableCell key={"desiredNumAcres"}>
      {harvest.desiredNumAcres || "N/A"}
    </TableCell>,
    <TableCell key={"transplantDate"}>
      {extractDate(harvest.transplantDate) || "N/A"}
    </TableCell>,
    <TableCell key={"projectedWetDate"}>
      {extractDate(harvest.projectedWetDate) || "N/A"}
    </TableCell>,
    <TableCell key={"estHarvestDate"}>
      {extractDate(harvest.estHarvestDate) || "N/A"}
    </TableCell>,
    <TableCell key={"fieldVarieties"}>
      {harvest.fieldVarieties
        ? harvest.fieldVarieties.map((v) => v?.variety?.name).join(", ")
        : "N/A"}
    </TableCell>,
    <TableCell key={"bedWidth"}>{harvest.bedWidth || "N/A"}</TableCell>,
    <TableCell key={"seedLine"}>{harvest.seedLine || "N/A"}</TableCell>,
  ];
}

function buildRowSX(harvest: HarvestList): object {
  return {
    backgroundColor: harvest?.commodity?.color,
  };
}

export default function HarvestCombinedScheduledListPage() {
  const [openFilter, setOpenFilter] = React.useState<boolean>(false);
  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="h2">Combined Schedule</Typography>
          </Box>
          <Box
            sx={{
              flexShrink: 1,
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Button onClick={() => setOpenFilter(!openFilter)}>
              <FilterListIcon />
            </Button>
          </Box>
        </Box>

        <HarvestFilterList
          buildTableRow={buildTableRow}
          buildRowSX={buildRowSX}
          columns={columns}
          defaultOrderBy={"projectedWetDate"}
          harvestStateFilter="all"
          modelBaseUrl={"harvests"}
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
        />
      </Box>
    </Layout>
  );
}
